/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./masonry.component";
var styles_MasonryComponent = [];
var RenderType_MasonryComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_MasonryComponent, data: {} });
export { RenderType_MasonryComponent as RenderType_MasonryComponent };
export function View_MasonryComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_MasonryComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "div", [["masonry", ""]], null, null, null, View_MasonryComponent_0, RenderType_MasonryComponent)), i0.ɵdid(1, 245760, null, 0, i1.MasonryComponent, [i0.ElementRef, "isBrowser"], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MasonryComponentNgFactory = i0.ɵccf("[masonry]", i1.MasonryComponent, View_MasonryComponent_Host_0, { options: "options", useImagesLoaded: "useImagesLoaded" }, { layoutComplete: "layoutComplete", removeComplete: "removeComplete" }, ["*"]);
export { MasonryComponentNgFactory as MasonryComponentNgFactory };
//# sourceMappingURL=masonry.component.ngfactory.js.map